import React, { useState } from "react";
import "../Style/Component/Approvalcard.css";
import profile from "../Assets/Approvalcard/06.png";
import to from "../Assets/Approvalcard/to.svg";
import approve from "../Assets/Approvalcard/approve.svg";
import driver from "../Assets/Approvalcard/driver.jpg";
import up from "../Assets/Approvalcard/up.svg";
import { useSelector } from "react-redux";
import { putWithTokenAPI } from "../Util/Api";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
const Approvalcard = ({ card, onApproveSuccess }) => {
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const permission = auth?.permission;
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  function limitWords(address) {
    if (!address) return "";

    const words = address.trim().split(/\s+/);

    if (words.length <= 5) return address;

    return words.slice(0, 5).join(" ") + "...";
  }
  const giveApprove = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        is_driver_form: "Approved",
      };

      const response = await putWithTokenAPI(
        token,
        `/user/update/${card._id}`,
        payload,
      );

      if (response?.statusCode == 200) {
        toast.success("Driver approved successfully");
        onApproveSuccess?.();
      }
    } catch (error) {
      console.error("Error in Approving:", error);
    }
  };
  const givecancel = (e) => {
    Swal.fire({
      title: "Reject Driver?",
      text: "Are you sure you want to reject this driver?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#8e101c",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Reject",
    }).then((result) => {
      if (result.isConfirmed) {
        handleCancel(e);
      }
    });
  };

  const handleCancel = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        is_driver_form: "Rejected",
      };

      const response = await putWithTokenAPI(
        token,
        `/user/update/${card._id}`,
        payload,
      );

      if (response?.statusCode == 200) {
        // setShowLogoutAlert(false);
        toast.success("Driver approval cancelled");
        onApproveSuccess?.();
      }
    } catch (error) {
      toast.error("Failed to cancel approval");
      console.error("Error in Approving:", error);
    }
  };
  return (
    <div className="approvalcard">
      {/* IMAGE */}
      <img
        src={card?.profileimage || driver}
        className={`approvalcardimage ${
          expanded ? "approvalcardimage--shrink" : ""
        }`}
        alt="profile"
      />

      {/* DETAILS */}
      <div
        className={`approvalcarddetails ${
          expanded ? "approvalcarddetails--expand" : ""
        }`}
        onClick={() => setExpanded(!expanded)}
      >
        {/* UP ARROW */}
        <span className="up" onClick={() => setExpanded(!expanded)}>
          <img
            src={up}
            className={`uparrow ${expanded ? "rotate" : ""}`}
            alt="toggle"
          />
        </span>

        <img
          src={to}
          className="to"
          alt="to"
          onClick={() => navigate(`/admin/drivervehicledetails/approval/${card._id}`)}
        />

        <span className="approvename">{card?.name}</span>
        <span className="approvenumber">+91 {card?.phoneNumber}</span>

        <span className="approveaddress">
          <b>Address :</b> {limitWords(card?.location1?.[0]?.currentAddress)}
        </span>

        <span className="approveaadhar">
          <b>Aadhar :</b> {card?.aadhaarnumber}
        </span>

        <div className="approvecardbuttons">
          {permission?.approval?.delete && (
            <button className="approvecancel" onClick={(e) => givecancel(e)}>
              Cancel
            </button>
          )}
          {permission?.approval?.update && (
            <button
              className="approvecardbutton"
              onClick={(e) => giveApprove(e)}
            >
              <img src={approve} alt="approve" />
              Approve
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Approvalcard;
